import { sb } from "../sb.ts";
import { logoUrl, type Brand } from "../brand.ts";
import { getLang, setLang, t } from "../i18n.ts";
import { h, mount } from "../ui.ts";

export function signIn(root: HTMLElement, brand: Brand, reroute: () => void) {
  const email = h("input", { type: "email", autocomplete: "username", required: true, placeholder: "you@company.com", dir: "ltr" });
  const pw = h("input", { type: "password", autocomplete: "current-password", required: true });
  const msg = h("p", { class: "muted" });
  const logo = logoUrl(brand.logo_path);
  mount(root, h("main", { class: "card narrow" },
    h("div", { class: "row end" }, h("button", { class: "link", onclick: () => { setLang(getLang() === "ar" ? "en" : "ar"); reroute(); } },
      getLang() === "ar" ? "English" : "العربية")),
    logo && h("img", { class: "logo", src: logo, alt: "" }),
    h("h1", {}, brand.app_name || brand.company_name || t("Sign in")),
    h("form", { onsubmit: async (e: Event) => {
      e.preventDefault();
      msg.textContent = t("Signing in…");
      const { error } = await sb.auth.signInWithPassword({ email: email.value.trim(), password: pw.value });
      msg.textContent = error ? error.message : "";
    } },
      h("label", {}, t("Email"), email), h("label", {}, t("Password"), pw),
      h("button", { class: "primary", type: "submit" }, t("Sign in"))),
    h("button", { class: "link", onclick: async () => {
      if (!email.value.trim()) { msg.textContent = t("Type your email first."); return; }
      const { error } = await sb.auth.resetPasswordForEmail(email.value.trim(), { redirectTo: location.origin + import.meta.env.BASE_URL });
      msg.textContent = error ? error.message : t("If that email has an account, a link to choose a new password is on its way.");
    } }, t("Forgot password?")),
    msg));
}
